import { EditorState, ContentState, Modifier, SelectionState } from 'draft-js';

import { Map } from 'immutable';

import has from 'lodash/has';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import find from 'lodash/find';
import escapeRegExp from 'lodash/escapeRegExp';

import isUndefined from 'lodash/isUndefined';
export const DEFAULT_MACRO_PREFIX = '{';
export const DEFAULT_MACRO_SUFFIX = '}';
export const DEFAULT_MACRO_ENTITY_NAME = '{mention';

export const convertTextToMentionsState = (
  startText = null,
  mentions = [],
  replaceEntityType = DEFAULT_MACRO_ENTITY_NAME,
  replaceMacroMap = {
    grouped: false,
    default: {
      prefix: DEFAULT_MACRO_PREFIX,
      suffix: DEFAULT_MACRO_SUFFIX,
    },
  },
) => {
  if (!startText) {
    return EditorState.createEmpty();
  } else {
    let contentState = ContentState.createFromText(startText);

    //iterate over block map.
    //replace block text with @mention entities using modifiers
    let contentStateWithMentions = !isEmpty(mentions)
      ? updateContentStateWithMentionEntities(
          contentState,
          mentions,
          replaceEntityType,
          replaceMacroMap,
        )
      : contentState;
    return EditorState.createWithContent(contentStateWithMentions);
  }
};

export const updateContentStateWithMentionEntities = (
  contentState,
  mentions,
  replaceEntityType = DEFAULT_MACRO_ENTITY_NAME,
  replaceMacroMap = {
    grouped: false,
    default: {
      prefix: DEFAULT_MACRO_PREFIX,
      suffix: DEFAULT_MACRO_SUFFIX,
    },
  },
) => {
  let contentStateWithEntities = contentState;
  let blockMap = contentStateWithEntities.getBlockMap();

  let macrosByGroup = has(replaceMacroMap, 'grouped') && replaceMacroMap.grouped === true;
  let defaultReplaceMacroPrefix =
    macrosByGroup && has(replaceMacroMap, 'default.prefix')
      ? replaceMacroMap.default.prefix
      : DEFAULT_MACRO_PREFIX;
  let defaultReplaceMacroSuffix =
    macrosByGroup && has(replaceMacroMap, 'default.suffix')
      ? replaceMacroMap.default.suffix
      : DEFAULT_MACRO_SUFFIX;

  //
  // let replaceMacroPrefix = replaceMacroMap.default.prefix;
  // let replaceMacroSuffix = replaceMacroMap.default.suffix;
  let defaultRegex = new RegExp(
    String.raw({
      raw: `${escapeRegExp(defaultReplaceMacroPrefix)}([^${escapeRegExp(
        defaultReplaceMacroSuffix,
      )}]+)${escapeRegExp(defaultReplaceMacroSuffix)}`, // eslint-disable-line no-useless-escape
    }),
    'gm',
  );

  let regexPatternMap = reduce(
    replaceMacroMap,
    (regexMap, v, k) => {
      if (k !== 'grouped' && k !== 'default') {
        let prefix = has(v, 'prefix') ? v.prefix : defaultReplaceMacroPrefix;
        let suffix = has(v, 'suffix') ? v.suffix : defaultReplaceMacroSuffix;
        regexMap[k] = new RegExp(
          String.raw({
            raw: `${escapeRegExp(prefix)}([^${escapeRegExp(suffix)}]+)${escapeRegExp(suffix)}`, // eslint-disable-line no-useless-escape
          }),
          'gm',
        );
      }

      return regexMap;
    },
    { default: defaultRegex },
  );

  blockMap.forEach((block) => {
    // const blockText = block.getText();
    const blockKey = block.getKey();

    forEach(regexPatternMap, (regexPattern, regexType) => {
      let blockText = contentStateWithEntities.getBlockForKey(blockKey).getText();
      let match = null;
      // console.log(blockText);
      // let replaceCount = 0;

      // eslint-disable-next-line no-cond-assign
      while ((match = regexPattern.exec(blockText)) !== null) {
        let textToReplace = match[0];

        let replaceText = textToReplace;
        let replaceAtIndex = match.index;
        let replaceToIndex = regexPattern.lastIndex;
        let entityData = find(mentions, (m) => {
          return (
            m.name === replaceText &&
            (m.type === regexType || (regexType === 'default' && !has(regexPatternMap, m.type)))
          );
        });
        if (!isUndefined(entityData)) {
          //create entity
          // console.log(match);
          // console.log(entityData);
          contentStateWithEntities = contentStateWithEntities.createEntity(
            replaceEntityType,
            'IMMUTABLE',
            { mention: Map(entityData) },
          );

          let entityKey = contentStateWithEntities.getLastCreatedEntityKey();

          // let replacementLength =
          //   replaceCount * (textToReplace.length - replaceText.length);

          let replaceTextSelection = new SelectionState({
            anchorKey: blockKey,
            anchorOffset: replaceAtIndex,
            focusKey: blockKey,
            focusOffset: replaceToIndex,
          });

          //replace the text with the entity.
          contentStateWithEntities = Modifier.applyEntity(
            contentStateWithEntities,
            replaceTextSelection,
            entityKey,
          );

          // contentStateWithEntities = Modifier.replaceText(
          //   contentStateWithEntities,
          //   replaceTextSelection,
          //   replaceText,
          //   null,
          //   entityKey
          // );
          // replaceCount++;
        }
      }
    });
  });

  return contentStateWithEntities;
};

export const extractPayloadFromMentionContent = (
  contentState,
  replaceEntityType = DEFAULT_MACRO_ENTITY_NAME,
  stripWhiteSpace = true,
  mentions = null,
  replaceMacroMap = {
    grouped: false,
    default: {
      prefix: DEFAULT_MACRO_PREFIX,
      suffix: DEFAULT_MACRO_SUFFIX,
    },
  },
) => {
  let text = contentState.getPlainText();

  // const blockMap = contentState.getBlockMap();
  //
  // let rawText = null;
  // let payloadText = null;
  // let allBlockText = [];
  //
  // let macrosByGroup =
  //   has(replaceMacroMap, 'grouped') && replaceMacroMap.grouped === true;
  // let defaultReplaceMacroPrefix =
  //   macrosByGroup && has(replaceMacroMap, 'default.prefix')
  //     ? replaceMacroMap.default.prefix
  //     : DEFAULT_MACRO_PREFIX;
  // let defaultReplaceMacroSuffix =
  //   macrosByGroup && has(replaceMacroMap, 'default.suffix')
  //     ? replaceMacroMap.default.suffix
  //     : DEFAULT_MACRO_SUFFIX;
  //
  // blockMap.forEach((block) => {
  //   const blockText = block.getText();
  //   let mentionEntityRanges = [];
  //   let blockTextMap = [];
  //   rawText = rawText ? `${rawText}\n${blockText}` : blockText;
  //
  //   //first find start and end of all mentions.
  //
  //   block.findEntityRanges(
  //     (value) => {
  //       const entityKey = value.getEntity();
  //       let isMention = false;
  //       if (entityKey) {
  //         let type = contentState.getEntity(entityKey).get('type');
  //         isMention = type === replaceEntityType;
  //       }
  //       return isMention;
  //     },
  //     (start, end) => {
  //       let entityRange = {
  //         start,
  //         end: end - 1,
  //         text: `${blockText.slice(start, end)}`,
  //         data: null
  //       };
  //
  //       if (macrosByGroup) {
  //         let entityKey = block.getEntityAt(start);
  //         entityRange.data = entityKey
  //           ? contentState.getEntity(entityKey).get('data')
  //           : null;
  //       }
  //
  //       mentionEntityRanges.push(entityRange);
  //     }
  //   );
  //
  //   let numEntities = mentionEntityRanges.length;
  //   let blockTextLength = blockText.length;
  //
  //   //now create an array per block that separates regular input from the mention input.
  //
  //   if (numEntities === 0) {
  //     blockTextMap.push({ text: blockText, type: 'default' });
  //   } else {
  //     forEach(mentionEntityRanges, (range, idx) => {
  //       let prevRange = idx !== 0 ? mentionEntityRanges[idx - 1] : null;
  //       //let nextRange = (idx < length -1) ? mentionEntityRanges[idx+1] : null;
  //       if (idx === 0 && range.start > 0) {
  //         blockTextMap.push({
  //           text: blockText.slice(0, range.start),
  //           type: 'default'
  //         });
  //       } else if (prevRange) {
  //         blockTextMap.push({
  //           text: blockText.slice(prevRange.end + 1, range.start),
  //           type: 'default'
  //         });
  //       }
  //
  //       blockTextMap.push({
  //         text: range.text,
  //         type: replaceEntityType,
  //         data: range.data
  //       });
  //
  //       if (idx === numEntities - 1 && range.end < blockTextLength - 1) {
  //         blockTextMap.push({
  //           text: blockText.slice(range.end + 1, blockTextLength)
  //         });
  //       }
  //     });
  //   }
  //   // console.log(blockTextMap);
  //   allBlockText.push(blockTextMap);
  // });
  //
  // // console.log(allBlockText);
  //
  // //now process all block maps to handle whitespaces introduced as part of mentions as well as prefix and suffix required for payload.
  // let numTotalBlocks = allBlockText.length;
  //
  // payloadText = reduce(
  //   allBlockText,
  //   (allPayloadAcc, currentBlockTextArray, idx) => {
  //     let numEntriesInBlock = currentBlockTextArray.length;
  //
  //     return reduce(
  //       currentBlockTextArray,
  //       (blockPayloadAcc, thisTextBlock, textBlockIdx) => {
  //         const { text, type } = thisTextBlock;
  //
  //         if (type === replaceEntityType) {
  //           let data = has(thisTextBlock, 'data.mention')
  //             ? thisTextBlock.data.mention
  //             : null;
  //
  //           if (macrosByGroup && data && has(replaceMacroMap, data['type'])) {
  //             let mentionType = data['type'];
  //             let mentionPrefix = replaceMacroMap[mentionType].prefix;
  //             let mentionSuffix = replaceMacroMap[mentionType].suffix;
  //             blockPayloadAcc += `${mentionPrefix}${text}${mentionSuffix}`;
  //           } else {
  //             blockPayloadAcc += `${defaultReplaceMacroPrefix}${text}${defaultReplaceMacroSuffix}`;
  //           }
  //         } else {
  //           let textToAdd = text;
  //           if (stripWhiteSpace === true) {
  //             //if there is a next item AND it is a mention AND the last char is whitespace, strip it.
  //             // console.log('start' + text);
  //             if (
  //               textBlockIdx < numEntriesInBlock - 1 &&
  //               currentBlockTextArray[textBlockIdx + 1].type ===
  //                 replaceEntityType &&
  //               text.charAt(text.length - 1) === ' '
  //             ) {
  //               // console.log('old' + text);
  //               textToAdd = text.slice(0, -1);
  //               // console.log('new' + textToAdd);
  //             }
  //
  //             //if there is a prev item AND it is a mention AND the first char is a whitespace, strip it.
  //             if (
  //               textBlockIdx > 0 &&
  //               currentBlockTextArray[textBlockIdx - 1].type ===
  //                 replaceEntityType &&
  //               textToAdd.charAt(0) === ' '
  //             ) {
  //               // console.log('old2' + textToAdd);
  //               textToAdd = textToAdd.slice(1, textToAdd.length);
  //               // console.log('new2' + textToAdd);
  //             }
  //           }
  //           blockPayloadAcc += textToAdd;
  //           if (
  //             textBlockIdx === numEntriesInBlock - 1 &&
  //             idx !== numTotalBlocks - 1
  //           ) {
  //             blockPayloadAcc += '\n';
  //           }
  //         }
  //         return blockPayloadAcc;
  //       },
  //       allPayloadAcc
  //     );
  //   },
  //   ''
  // );
  return { rawText: text, payloadText: text };
};
